import { usePrivate } from '@/components/private';
import { useGetOrganisationSettings } from './useGetOrganisationSettings';
import { OrganisationSettingTypeCode } from '@/apiClient';
import { STANDARD_DATE_FORMAT } from '@/configs';

export default function useDateFormatFromOrgSettings(
  fallback = STANDARD_DATE_FORMAT,
) {
  const { selectedOrganisationId } = usePrivate();
  const { data } = useGetOrganisationSettings(selectedOrganisationId);
  return (
    data?.data.find(
      ({ settingTypeCode }) =>
        settingTypeCode === OrganisationSettingTypeCode.DateDisplayFormat,
    )?.value || fallback
  );
}
